export var hideControlsClassName = 'mvng-hide-controls';